import React, { useState, useEffect } from 'react';
import { useForm, FormProvider } from 'react-hook-form';
import { post } from '@utils/axios_api';
import { useNavigate, Link } from 'react-router-dom';
import { AuthHook } from '@hooks';
import { Input, Checkbox } from '@components/form';


const LoginForm = () => {
    const {login} = AuthHook();
    const navigate = useNavigate();
    const [serverError, setServerError] = useState('');
    
    const methods = useForm({
        defaultValues: { id: '', password: '', saveId: false },
    });

    const { handleSubmit, reset, setValue, formState: { isSubmitting }, } = methods;

    useEffect(() => {
        const isIdSaved = localStorage.getItem('isIdSaved') === 'true';
        if (isIdSaved) {
            setValue('id', localStorage.getItem('savedUserId') || '');
            setValue('saveId', true);
        }
    }, [setValue]);


    const onSubmit = async ({ id, password, saveId }) => {
        setServerError('');
        try {
          await login({ username: id, password });
          if (saveId) {
            localStorage.setItem('savedUserId', id);
            localStorage.setItem('isIdSaved', 'true');
          } else {
            localStorage.removeItem('savedUserId');
            localStorage.setItem('isIdSaved', 'false');
          }
          navigate('/main');
          reset();
        } catch (err) {
            const msg = err.response?.data?.errorMessage || err.message || '로그인에 실패했습니다.';
            setServerError(msg);
        }
      };

    return (
        <FormProvider {...methods}>
        <div className="loginbox mu_member">
            <form onSubmit={handleSubmit(onSubmit)} className="loginForm" autoComplete="off">
                <dl className="inputBox">
                    <dd>
                        <div className="fz35 bold">Login</div>
                        {serverError && <p className="error-message">{serverError}</p>}
                        <div className="id_input_wrap">
                            <div>
                                <p className="fz16 fw500">아이디</p>
                                <Input
                                    name="id"
                                    type="text"
                                    placeholder="아이디를 입력해 주세요."
                                    required={true}
                                    maxLength="30"
                                    className="c2 enterArea"
                                />
                            </div>
                            <div>
                                <p className="fz16 fw500">비밀번호</p>
                                <Input
                                    name="password"
                                    type="password"
                                    placeholder="비밀번호를 입력해 주세요."
                                    required={true}
                                    maxLength="20"
                                    className="c4 enterArea"
                                    autoComplete="new-password"
                                />
                            </div>
                        </div>
                    </dd>
                </dl>
                <div className="f_b">
                    <Checkbox
                        label="아이디 저장"
                        name="saveId"
                        required={false}
                        className="idSaveBox input_chk"
                        checkboxClassName="checkbox"
                        labelClassName="input_chk_label fz13 fw500" 
                    />
                    <p className="menuBox">
                        <Link to="/findid"><span className="fz13 fw600">아이디 찾기</span></Link>
                        <Link to="/findid"><span className="fz13 fw600">비밀번호 찾기</span></Link>
                    </p>
                </div>
                <button type="submit" className="btn_login btn_submit btn_color wid" disabled={isSubmitting}>
                    {isSubmitting ? '로그인 중...' : '로그인'}
                </button>
            </form>
        </div>
        </FormProvider>
    );
};

export default LoginForm;
